<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="مدیریت پیام های زمان دار"
        >
          <b-form
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>
                  <b-col
                    class="image"
                    cols="12"
                  >
                    <fm-file-select v-model="selectedImage" @select="val=>setImageId(val)" label="عکس" :entity="15" />
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="متن پیام"
                      label-for="Title"
                    >
                      <b-form-textarea
                        rows="8"
                        id="Title"
                        v-model="Form.MessageText"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                        label="گروه چت"
                        label-for="MessageGroupId"
                    >
                      <groupMessageSelector
                          v-model="Form.MessageGroupId"
                          :clearable="true"
                          :multiple="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                        label="تاریخ "
                        label-for="StartDate"
                    >
                      <date-picker
                          v-model="Form.Schedule"
                          placeholder=""
                          type="datetime"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY-jMM-jDD HH:mm"
                          clearable
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                        label="پین شود"
                    >
                      <b-form-checkbox
                          v-model="Form.Pinned"
                          class="mr-0"
                          name="is-rtl"
                          switch
                          inline
                      />
                    </b-form-group>
                  </b-col>
                    <b-col md="3">
                    <b-form-group
                        label="پیام از نوع چالش"
                    >
                      <b-form-checkbox
                          v-model="Form.IsChallenge"
                          class="mr-0"
                          name="is-rtl"
                          switch
                          inline
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3" v-if="Form.IsChallenge">
                    <b-form-group
                        label="تاریخ پایان چالش"
                    >
                      <date-picker
                          v-model="Form.ChallengeEndAt"
                          placeholder=""
                          type="datetime"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY-jMM-jDD HH:mm"
                          clearable
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZBannerPosition from '@/tools/bannerposition.vue'
import selectSegmentCustom from '@/tools/selectSegmentCustom.vue'
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue"
import groupMessageSelector from "@/tools/groupMessageSelector.vue";

export default {
  name: 'ScheduleDetails',
  components: {
    groupMessageSelector,
    ZBannerPosition,
    selectSegmentCustom,
    FmFileSelect
  },
  data() {
    return {
      selectedImage: null,
      Form: {
        FileManagerId:null,
        MessageText:null,
        Schedule:null,
        MessageGroupId:null,
        Pinned:false,
        IsChallenge:false,
        ChallengeEndAt:null
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.messenger.ScheduleMessageSet
      if (this.$route.params.id) {
        url = this.$api.messenger.ScheduleMessageUpdate
      }
      this.loading = true
      this.$http.post(url, this.Form)
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.get(
        this.$api.messenger.ScheduleMessageGet, {
          params:{Id: this.Form.Id},
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.selectedImage = res.data.File
        })
    },
    setImageId(val){
      this.Form.FileManagerId=val.Id
    }
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
